export default "__VITE_ASSET__gYkq8cDf__"